export default "__VITE_ASSET__QgjJsw4w__"